"use client";

import ModalCloseIcon from "@/assets/icons/modal-close.svg";
import Image from "next/image";
import Link from "next/link";
import { memo, useEffect, useState } from "react";

interface ModalHeaderProps {
  onClose: () => void;
}

export const ModalHeader = memo(function ModalHeader(props: ModalHeaderProps) {
  const { onClose } = props;
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let isAnimationFrameQueued = false;
    let rafId: number | null = null;

    function updateScrolledState() {
      const hasScrolled = window.scrollY > 0;
      setIsScrolled(hasScrolled);
    }

    function onScroll() {
      if (!isAnimationFrameQueued) {
        rafId = requestAnimationFrame(() => {
          updateScrolledState();
          isAnimationFrameQueued = false;
          rafId = null;
        });
        isAnimationFrameQueued = true;
      }
    }

    // 初始检查
    updateScrolledState();

    // 监听滚动
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
    };
  }, []);

  return (
    <div
      className={`sticky top-0 transition-all duration-300 w-full z-50 mx-auto flex h-[60px] items-center justify-between px-5 lg:pl-8 lg:pr-[60px] ${
        isScrolled
          ? "bg-white/38 backdrop-blur-[11px] shadow-[0_3.45px_29.785px_0_rgba(0,123,255,0.03)]"
          : "bg-transparent"
      }`}
    >
      <Link href="/">
        <div className="flex items-center gap-2">
          <Image src="/text-logo.png" alt="VidMuse" width={131} height={32} />
        </div>
      </Link>

      <button
        type="button"
        className="cursor-pointer border-0 bg-transparent p-0"
        onClick={onClose}
        aria-label="Close modal"
      >
        <ModalCloseIcon className="h-5 w-5 text-gray-secondary" />
      </button>
    </div>
  );
});
